import {
  Container,
  Flex,
  Table,
  Text,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Badge,
  Button,
  Box,
  Heading,
  Spinner,
  Checkbox,
} from '@chakra-ui/react'
import { NextSeo } from 'next-seo'
import { useState } from 'react'
import Balancer from 'react-wrap-balancer'
import { Address, useAccount } from 'wagmi'

import { ConnectWallet, RevokeDialogue } from '@/components'
import { useIsClient, useEventLogs } from '@/hooks'
import { formatAddress } from '@/utils/formatAddress'

interface ISelectedRevoke {
  spenderAddress: Address
  contractAddress: Address
}

const Activity = () => {
  const isClient = useIsClient()
  const { isConnected } = useAccount()
  const { data: erc721Events, isLoading } = useEventLogs()
  const [selectedRevoke, setselectedRevoke] = useState<ISelectedRevoke | undefined>()
  const [hideZeroBalance, setHideZeroBalance] = useState(true)

  if (!isConnected && isClient) {
    return <ConnectWallet />
  }

  const filteredERC721Events = erc721Events
    ?.filter((z) => z !== undefined)
    .filter((z) => z?.allowances.length !== 0)
    .filter((z) => !hideZeroBalance || (z?.balance ?? 0) > 0)
    .flatMap((event) =>
      event?.allowances.map((allowance) => ({
        ...event,
        allowance: allowance,
      }))
    )

  return (
    <>
      <RevokeDialogue
        selectedRevoke={selectedRevoke}
        onClose={() => setselectedRevoke(undefined)}
      />
      <Box w="full">
        <Flex
          textAlign="center"
          flexDir="column"
          justifyContent="center"
          alignItems="center"
          my="12"
          mx="auto"
          maxW="xl"
          // position="relative"
        >
          {/* <Box
          rounded="full"
          bgGradient="linear(to-r, brand.500, pink.500)"
          h={100}
          opacity={0.6}
          sx={{ aspectRatio: 1 }}
          zIndex="0"
          position="absolute"
          bottom="calc(100% - 150px)"
          maxW="lg"
          w="full"
          filter="blur(64px)"
        /> */}
          <Heading mt="8" zIndex="1">
            <Balancer>Revoke Approvals</Balancer>
          </Heading>
          <Text mt="3" zIndex="1" color="slate.600">
            <Balancer>
              FoolProof Token (FPT) offers unparalleled security and control over digital assets by
              creating a 1:1 linked token to prove ownership without risking ownership.
            </Balancer>
          </Text>
        </Flex>

        <Container
          my={{ base: 8, md: 12 }}
          p={{ base: 4, md: 12 }}
          maxW="4xl"
          rounded={'md'}
          w="full"
          marginX="auto"
          borderWidth={{ base: 0, md: 1 }}
        >
          <NextSeo title="Revoke" />
          <Flex mb="10" flexDirection="column">
            <Flex justifyContent="space-between" alignItems="center">
              <Text fontSize="xl" fontWeight="bold">
                Revoke
              </Text>
              <Checkbox
                isChecked={hideZeroBalance}
                onChange={(e) => setHideZeroBalance(e.target.checked)}
              >
                Hide zero balance
              </Checkbox>
            </Flex>

            {isLoading ? (
              <Spinner mx="auto" my="10" />
            ) : (
              <Table variant="unstyled" colorScheme="brand" mt="10">
                <Thead>
                  <Tr borderBottomWidth={1}>
                    <Th>
                      <Text>Token</Text>
                    </Th>
                    <Th w="50px">Type</Th>
                    <Th w="100px">Amount</Th>
                    <Th w="100px">Spender</Th>
                    <Th w="100px" textAlign="right">
                      Action
                    </Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {filteredERC721Events?.map((token) => (
                    <Tr
                      key={token?.transactionHash}
                      transition={{ color: '0.2s' }}
                      sx={{
                        transition: 'background-color 0.3s ease-in-out',
                      }}
                      _hover={{ bg: 'slate.200', _dark: { bg: 'slate.800' } }}
                    >
                      <Td>
                        {token?.contractName}{' '}
                        {token?.tokenType === 'erc20' && `($${token?.symbol})`}
                      </Td>
                      <Td w="100px">
                        <Badge
                          size={'sm'}
                          mb="2"
                          colorScheme={token?.tokenType === 'erc20' ? 'orange' : 'teal'}
                        >
                          {token?.tokenType}
                        </Badge>
                      </Td>
                      <Td w="100px">{token?.balance.toFixed(2)}</Td>
                      <Td w="150px">
                        {token?.allowance.spender && formatAddress(token?.allowance.spender)}
                      </Td>

                      <Td w="100px">
                        <Button
                          onClick={() =>
                            setselectedRevoke({
                              spenderAddress: token?.allowance.spender,
                              contractAddress: token?.contractAddress as Address,
                            })
                          }
                          variant="outline"
                          size={'sm'}
                        >
                          Revoke
                        </Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            )}
          </Flex>
        </Container>
      </Box>
    </>
  )
}

export default Activity
